import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { BasicButton } from "../buttons/BasicButton";
import { CreateOperationReply } from "@/backend/express/controllers/operationController";
import { TableAddModal } from "./TableAddModal";
import { Container } from "@/backend/models/containers/container";

export function TableAddButton(props: {
  scenario: Container,
  onCreate: () => Promise<CreateOperationReply>
}) {
  const { scenario, onCreate } = props;
  const [showParameterModal, setShowParameterModal] = useState<boolean>(false);

  return (
  <>
    <div className='d-flex'>
      <BasicButton
        className='btn btn-sm btn-secondary'
        label={I18n.get('addTable')}
        onClick={() => setShowParameterModal(true)}
      />
    </div>
    {showParameterModal &&  <TableAddModal scenario={scenario} onCreate={onCreate} setShow={setShowParameterModal} />}
  </>
  );
}

